import { FormHelperText } from '@mui/material';
import { useL10n, useSexOptions } from '@uplift/hooks';
import { RadioControl } from '@uplift/ui-v2';
import { Form } from 'formik';

export const SexForm = () => {
  const l10n = useL10n();
  const { sexOptions } = useSexOptions(l10n);

  return (
    <Form>
      <RadioControl
        label=""
        name="sex"
        values={sexOptions}
      />
      <FormHelperText>{l10n.accountSettings.profile.binary}</FormHelperText>
    </Form>
  );
};
